import {BaseApiModel} from "../../../infrastructure/models/base-api-model";

export class PublisherApiModel extends BaseApiModel {
  id: Number;
  name: String;
  countryId: Number;
  bookmakerIdTerm: String;
  bookmakerLinkTerm: String;
  allScoresLinkTerm: String;

  constructor(model) {
    super(model);

    this.id = model.id;
    this.name = model.name;
    this.countryId = model.countryId;
    this.bookmakerIdTerm = model.bookmakerIdTerm;
    this.bookmakerLinkTerm = model.bookmakerLinkTerm;
    this.allScoresLinkTerm = model.allScoresLinkTerm;
  }
}
